"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignLayer = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const react_bootstrap_1 = require("react-bootstrap");
const Link_1 = __importStar(require("app/Components/Common/Link"));
const getItemFromLocalStorage = (key) => {
    if (window.localStorage) {
        return window.localStorage.getItem(key);
    }
};
const setItemToLocalStorage = (key, item) => {
    if (window.localStorage) {
        window.localStorage.setItem(key, item);
    }
};
const CampaignLayer = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const ctx = (0, spa_core_1.useEpiserver)();
    if (props.settings === undefined || ctx.isServerSideRendering())
        return react_1.default.createElement(react_1.default.Fragment, null);
    const img = ((_a = props.settings.campaignImage) === null || _a === void 0 ? void 0 : _a.value) ?
        react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: props.settings.campaignImage.value, className: 'd-cover', expandedValue: props.settings.campaignImage.expandedValue }) : null;
    const campaignText = ((_b = props.settings.campaignText) === null || _b === void 0 ? void 0 : _b.value) || ((_c = props.settings.campaignText) === null || _c === void 0 ? void 0 : _c.value) !== `<p></p>`
        ? (_d = props.settings.campaignText) === null || _d === void 0 ? void 0 : _d.value : props.settings.campaignText;
    const campaignCTAHref = ((_e = props.settings.buttonCTAHref) === null || _e === void 0 ? void 0 : _e.value) || props.settings.buttonCTAHref;
    const campaignCTATitle = ((_f = props.settings.buttonCTATitle) === null || _f === void 0 ? void 0 : _f.value) || props.settings.buttonCTATitle;
    const shouldShowModal = () => {
        var _a;
        if (!((_a = props.settings.showCampaignLayer) === null || _a === void 0 ? void 0 : _a.value))
            return false;
        const lastTimestamp = getItemFromLocalStorage(keyEntry);
        if (!lastTimestamp) {
            return true;
        }
        const parsedTimestamp = parseInt(lastTimestamp, 10);
        const expiryLimit = new Date(parsedTimestamp);
        if (isNaN(expiryLimit.getTime())) {
            window.localStorage.removeItem(keyEntry);
        }
        if (props.settings.campaignBannedHours || props.settings.campaignBannedHours.value) {
            const bannedHours = typeof (props.settings.campaignBannedHours) === 'number' ? props.settings.campaignBannedHours : props.settings.campaignBannedHours.value;
            expiryLimit.setHours(expiryLimit.getHours() + bannedHours);
            return new Date() > expiryLimit;
        }
        return true;
    };
    const keyEntry = 'campaignLayerTimestamp';
    const [modalShow, setModalShow] = react_1.default.useState(() => shouldShowModal());
    const imagewrapClass = `image-wrap ${typeof ((_g = props.settings.campaignImageBackgroundColor) === null || _g === void 0 ? void 0 : _g.value) === 'string' ? props.settings.campaignImageBackgroundColor.value : props.settings.campaignImageBackgroundColor}`;
    const addtionalAspectRatio = typeof ((_h = props.settings.campaignImageAdditionalAspectRatio) === null || _h === void 0 ? void 0 : _h.value) === 'boolean' ? props.settings.campaignImageAdditionalAspectRatio.value : props.settings.campaignImageAdditionalAspectRatio;
    const CampaignModal = () => {
        return (react_1.default.createElement(Modal_1.default, { show: modalShow, onHide: () => setModalShow(false), size: "lg", "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: 'campaign-modal pe-0', onShow: () => setItemToLocalStorage(keyEntry, new Date().getTime().toString()) },
            react_1.default.createElement(react_bootstrap_1.ModalHeader, null,
                react_1.default.createElement("div", { className: 'row' },
                    react_1.default.createElement("div", { className: 'col-12' },
                        react_1.default.createElement("div", { className: imagewrapClass, style: { aspectRatio: addtionalAspectRatio ? 'auto 1000/350' : 'auto 16/9' } }, img)),
                    react_1.default.createElement("div", { className: 'btn close position-absolute end-0', "settings-dismiss": 'modal' },
                        react_1.default.createElement("a", { role: 'button', tabIndex: 0, onClick: () => setModalShow(false), className: 'd-flex align-items-center' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'closeText' }),
                            react_1.default.createElement("span", { className: 'icon-close' }))))),
            react_1.default.createElement(Modal_1.default.Body, { className: 'p-9 p-sm-10' },
                react_1.default.createElement("div", { className: 'row' },
                    react_1.default.createElement("div", { className: 'col-12' },
                        react_1.default.createElement("h3", { className: 'modal-title pb-6 text-start', id: 'modalLabel' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.settings, field: 'campaignHeader' })))),
                react_1.default.createElement("div", { className: 'row justify-content-sm-between' },
                    react_1.default.createElement("div", { className: 'col-12 col-sm-8 col-md-7' }, campaignText &&
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: campaignText } })),
                    react_1.default.createElement("div", { className: 'col-12 col-sm-auto d-flex mx-0 justify-content-start justify-content-sm-end align-self-start', "settings-dismiss": 'modal' },
                        react_1.default.createElement("div", { className: 'h-auto' },
                            react_1.default.createElement(Link_1.default, { type: Link_1.LinkType.Outline_Button, icon_class: 'icon-arrow-right-tail', target: Link_1.LinkTarget.New_window, href: campaignCTAHref, title: campaignCTATitle })))))));
    };
    return react_1.default.createElement(CampaignModal, null);
};
exports.CampaignLayer = CampaignLayer;
exports.default = exports.CampaignLayer;
